var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"spinner",attrs:{"icon":"","small":""}},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("mdi-cog")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }